export default __webpack_public_path__ + "static/media/12.c8cd9fea.jpg";